<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    max-width="1200"
    scrollable
  >
    <v-card v-if="item">
      <v-card-title>
        <v-list-item class="ml-n4">
          <v-list-item-avatar size="44" class="mr-3" color="blue-grey lighten-4">
            <v-icon color="blue-grey">mdi-account</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="text-subtitle-1 font-weight-medium text-truncate">
              {{ item.cliente }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <span v-if="periodo_label" class="mr-1">{{ periodo_label }} &mdash;</span>
              Totale: <strong>{{ item.value.totale.toFixed(2) }} €</strong>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-btn icon small @click="$emit('input', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item>
      </v-card-title>

      <v-tabs v-model="tab" height="32" background-color="grey lighten-4">
        <v-tab class="text-caption">Prodotti acquistati</v-tab>
        <v-tab class="text-caption">Trend spesa</v-tab>
      </v-tabs>
      <v-divider />

      <v-card-text class="pt-3" style="height: 600px; overflow-y: auto">

        <!-- ─── TAB 0: Prodotti top ─── -->
        <template v-if="tab === 0">
          <v-row v-if="loading_dettaglio" justify="center" class="mt-8">
            <v-progress-circular indeterminate width="2" color="primary" />
          </v-row>
          <template v-else-if="prodotti_lista_merged.length">
            <v-row no-gutters class="font-weight-medium text-caption grey--text mb-2">
              <v-col cols="6" class="pl-9">Prodotto</v-col>
              <v-col cols="2" class="d-flex justify-end pr-2">Qta</v-col>
              <template v-if="show_confronta">
                <v-col cols="2" class="d-flex justify-end pr-2">Rif.</v-col>
                <v-col cols="2" class="d-flex justify-end pr-2">Var %</v-col>
              </template>
            </v-row>
            <div v-for="(group, gi) in prodotti_per_sottocategoria" :key="gi">
              <!-- intestazione sottocategoria -->
              <v-row  align="center" class="mt-3 mb-1 grey lighten-4 rounded">
                <v-col cols="12" class="d-flex align-center">
                  <span class="text-caption grey--text mr-1">{{ group.categoria }}</span>
                  <v-icon x-small class="grey--text mr-1">mdi-chevron-right</v-icon>
                  <span class="text-caption font-weight-bold primary--text">{{ group.sotto_categoria }}</span>
                  <v-spacer />
                  <template v-if="show_confronta && group.variazione !== null">
                    <v-chip
                      x-small
                      :color="Number(group.variazione) >= 0 ? 'green' : 'red'"
                      dark
                      class="ml-2 text-caption"
                    >
                      {{ Number(group.variazione) >= 0 ? '+' : '' }}{{ group.variazione }} %
                    </v-chip>
                  </template>

                </v-col>
              </v-row>
              <!-- righe prodotto -->
              <v-hover
                v-for="(p, i) in group.prodotti"
                :key="i"
                v-slot="{ hover }"
              >
                <v-row
                  no-gutters
                  align="center"
                  class="my-1 px-1 rounded"
                  :class="hover ? 'grey lighten-4' : ''"
                >
                  <v-col cols="6" class="d-flex align-center text-body-2">
                    <v-avatar size="28" class="mr-2">
                      <v-img :src="avatar_img_prodotto(p)" />
                    </v-avatar>
                    <span class="text-truncate">{{ nome_prodotto(p) }}</span>
                  </v-col>
                  <v-col cols="2" class="d-flex justify-end pr-2 text-body-2 font-weight-medium">
                    {{ p.qta }}
                  </v-col>
                  <template v-if="show_confronta">
                    <v-col cols="2" class="d-flex justify-end pr-2 text-body-2 grey--text">
                      {{ qta_confronto(p) || '—' }}
                    </v-col>
                    <v-col
                      cols="2"
                      class="d-flex justify-end pr-2 text-body-2"
                      :class="var_class(p.qta, qta_confronto(p))"
                    >
                      {{ var_pct(p.qta, qta_confronto(p)) }}
                    </v-col>
                  </template>
                </v-row>
              </v-hover>
            </div>
          </template>
          <v-row v-else justify="center" class="mt-8 grey--text text-caption">
            Nessun prodotto nel periodo
          </v-row>
        </template>

        <!-- ─── TAB 1: Trend spesa ─── -->
        <template v-else>
          <v-row v-if="loading_dettaglio" justify="center" class="mt-8">
            <v-progress-circular indeterminate width="2" color="green" />
          </v-row>
          <template v-else-if="chart_buckets.length">
            <VueApexCharts
              type="bar"
              height="480"
              :options="chart_options"
              :series="chart_series"
            />
          </template>
          <v-row v-else justify="center" class="mt-8 grey--text text-caption">
            Nessun dato per il periodo selezionato
          </v-row>
        </template>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import _ from "lodash";
import VueApexCharts from "vue-apexcharts";

export default {
  components: { VueApexCharts },
  props: {
    value: Boolean,
    item: Object,
    ts_inizio: [String, Number],
    ts_fine: [String, Number],
    show_confronta: {
      type: Boolean,
      default: false,
    },
    anno_rif: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      tab: 0,
      prodotti_top: [],
      prodotti_top_confronto: [],
      trend_data: [],
      trend_data_confronto: [],
      loading_dettaglio: false,
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.tab = 0;
        this.prodotti_top = [];
        this.prodotti_top_confronto = [];
        this.trend_data = [];
        this.trend_data_confronto = [];
        this.fetchDettaglio();
      }
    },
  },
  computed: {
    prodotti_lista_merged() {
      if (!this.show_confronta) return this.prodotti_top;
      const merged = this.prodotti_top.map((p) => ({ ...p }));
      const artsCorrente = new Set(this.prodotti_top.map((p) => p.art));
      this.prodotti_top_confronto.forEach((p) => {
        if (!artsCorrente.has(p.art)) {
          merged.push({ art: p.art, nome: p.nome, qta: 0 });
        }
      });
      return merged;
    },
    prodotti_per_sottocategoria() {
      const groups = new Map(); // key: "categoria||sotto_categoria"
      this.prodotti_lista_merged.forEach((p) => {
        const info = this.$store.getters.get_categoria_prodotto_by_id(p.art);
        const categoria = info ? info.categoria : "Altro";
        const sotto_categoria = info ? info.sotto_categoria : "Altro";
        const key = `${categoria}||${sotto_categoria}`;
        if (!groups.has(key)) {
          groups.set(key, { categoria, sotto_categoria, prodotti: [] });
        }
        groups.get(key).prodotti.push(p);
      });
      // calcola variazione % per gruppo
      return Array.from(groups.values()).map((g) => {
        const qta_tot = g.prodotti.reduce((s, p) => s + (p.qta || 0), 0);
        const qta_rif = g.prodotti.reduce((s, p) => s + (this.qta_confronto(p) || 0), 0);
        const variazione = qta_rif
          ? (((qta_tot - qta_rif) / qta_rif) * 100).toFixed(0)
          : null;
        return { ...g, qta_tot, qta_rif, variazione };
      });
    },
    periodo_label() {
      if (!this.ts_inizio || !this.ts_fine) return null;
      const wkStart = moment.unix(this.ts_inizio).isoWeek();
      const yrStart = moment.unix(this.ts_inizio).isoWeekYear();
      const wkEnd = moment.unix(this.ts_fine).isoWeek();
      const yrEnd = moment.unix(this.ts_fine).isoWeekYear();
      if (wkStart === wkEnd && yrStart === yrEnd) return `Wk ${wkStart}`;
      if (yrStart === yrEnd) return `Wk ${wkStart} – Wk ${wkEnd}`;
      return `Wk ${wkStart}/${yrStart} – Wk ${wkEnd}/${yrEnd}`;
    },
    by_month() {
      return (Number(this.ts_fine) - Number(this.ts_inizio)) / 86400 >= 180;
    },
    chart_buckets() {
      const valid = this.trend_data.filter(
        (r) => r.timeStamp && Number(r.timeStamp) > 0
      );
      const buckets = [];
      if (this.by_month) {
        const byMonth = _.groupBy(valid, (r) =>
          moment.unix(r.timeStamp).startOf("month").format("YYYY-MM")
        );
        const start = moment.unix(this.ts_inizio).startOf("month");
        const end = moment.unix(this.ts_fine).startOf("month");
        let cur = start.clone();
        while (cur.isSameOrBefore(end)) {
          const key = cur.format("YYYY-MM");
          buckets.push({ key, records: byMonth[key] || [] });
          cur.add(1, "month");
        }
      } else {
        const byWeek = _.groupBy(valid, (r) =>
          moment.unix(r.timeStamp).startOf("isoWeek").format("YYYY-MM-DD")
        );
        const start = moment.unix(this.ts_inizio).startOf("isoWeek");
        const end = moment.unix(this.ts_fine).startOf("isoWeek");
        let cur = start.clone();
        while (cur.isSameOrBefore(end)) {
          const key = cur.format("YYYY-MM-DD");
          buckets.push({ key, records: byWeek[key] || [] });
          cur.add(1, "week");
        }
      }
      return buckets;
    },
    confronto_bucket_map() {
      if (!this.show_confronta || !this.trend_data_confronto.length) return {};
      const valid = this.trend_data_confronto.filter(
        (r) => r.timeStamp && Number(r.timeStamp) > 0
      );
      if (this.by_month) {
        return _.groupBy(valid, (r) =>
          moment.unix(r.timeStamp).add(this.anno_rif, "year").startOf("month").format("YYYY-MM")
        );
      }
      return _.groupBy(valid, (r) =>
        moment.unix(r.timeStamp).add(this.anno_rif, "year").startOf("isoWeek").format("YYYY-MM-DD")
      );
    },
    chart_series() {
      const map = this.confronto_bucket_map;
      if (this.show_confronta) {
        return [
          {
            name: "Corrente",
            data: this.chart_buckets.map((b) =>
              b.records.reduce((s, r) => s + r.tot, 0).toFixed(2)
            ),
          },
          {
            name: "Riferimento",
            data: this.chart_buckets.map((b) => {
              const recs = map[b.key] || [];
              return recs.reduce((s, r) => s + r.tot, 0).toFixed(2);
            }),
          },
        ];
      }
      return [
        {
          name: "Verde",
          data: this.chart_buckets.map((b) =>
            b.records.filter((r) => r.verde).reduce((s, r) => s + r.tot, 0).toFixed(2)
          ),
        },
        {
          name: "Blu",
          data: this.chart_buckets.map((b) =>
            b.records.filter((r) => !r.verde).reduce((s, r) => s + r.tot, 0).toFixed(2)
          ),
        },
      ];
    },
    chart_options() {
      return {
        chart: { type: "bar", stacked: !this.show_confronta, toolbar: { show: false } },
        colors: this.show_confronta
          ? ["#1976D2", "#90CAF9"]
          : ["#00E676", "#448AFF"],
        plotOptions: { bar: { borderRadius: 2, columnWidth: this.show_confronta ? "70%" : "60%" } },
        xaxis: {
          categories: this.chart_buckets.map((b) =>
            this.by_month
              ? moment(b.key).format("MMM YY")
              : moment(b.key).format("DD MMM")
          ),
          labels: { style: { fontSize: "11px" }, rotate: -45 },
        },
        yaxis: { labels: { style: { fontSize: "11px" } } },
        legend: { position: "top", fontSize: "12px" },
        dataLabels: { enabled: false },
        tooltip: {
          x: {
            formatter: (_, opts) => {
              const b = this.chart_buckets[opts.dataPointIndex];
              if (!b) return "";
              return this.by_month
                ? moment(b.key).format("MMMM YYYY")
                : `Sett. ${moment(b.key).format("DD MMM")} – ${moment(b.key)
                    .endOf("isoWeek")
                    .format("DD MMM YYYY")}`;
            },
          },
        },
      };
    },
  },
  methods: {
    avatar_img_prodotto(p) {
      const prodotto = this.$store.getters.get_prodotto_by_id(p.art);
      if (!prodotto) return "";
      return `${process.env.VUE_APP_API_ROOT}/avatar_img/${prodotto.id}?t=${prodotto.avatar_md5}`;
    },
    nome_prodotto(p) {
      const prodotto = this.$store.getters.get_prodotto_by_id(p.art);
      return prodotto ? prodotto.nome.split(" in ")[0] : p.art;
    },
    qta_confronto(p) {
      const rif = this.prodotti_top_confronto.find((r) => r.art === p.art);
      return rif ? rif.qta : 0;
    },
    var_pct(corrente, confronto) {
      if (!confronto) return "N/D";
      return ((corrente * 100) / confronto - 100).toFixed(0) + " %";
    },
    var_class(corrente, confronto) {
      if (!confronto) return "grey--text";
      return corrente >= confronto ? "green--text" : "red--text";
    },
    fetchDettaglio() {
      if (!this.item) return;
      this.loading_dettaglio = true;
      const main = this.$store
        .dispatch("fetch_analisi_cliente_dettaglio", {
          iva: this.item.iva,
          ts_inizio: this.ts_inizio,
          ts_fine: this.ts_fine,
        })
        .then((data) => {
          this.prodotti_top = Array.isArray(data.prodotti_top) ? data.prodotti_top : [];
          this.trend_data = Array.isArray(data.ordini) ? data.ordini : [];
        });
      const fetches = [main];
      if (this.show_confronta) {
        const cf = this.$store
          .dispatch("fetch_analisi_cliente_dettaglio", {
            iva: this.item.iva,
            ts_inizio: moment.unix(this.ts_inizio).subtract(this.anno_rif, "year").format("X"),
            ts_fine: moment.unix(this.ts_fine).subtract(this.anno_rif, "year").format("X"),
          })
          .then((data) => {
            this.trend_data_confronto = Array.isArray(data.ordini) ? data.ordini : [];
            this.prodotti_top_confronto = Array.isArray(data.prodotti_top) ? data.prodotti_top : [];
          });
        fetches.push(cf);
      }
      Promise.all(fetches).finally(() => {
        this.loading_dettaglio = false;
      });
    },
  },
};
</script>
